// Compare every field: differing models, estimates or evidence must remain separate.
const stableValue = value => Array.isArray(value) ? value.map(stableValue)
  : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, stableValue(value[key])])) : value;
const timing = value => String(value || '').match(/(?:at\s+)?age\s+(\d+(?:\.\d+)?)\s*(years?|months?)/i);
export function sourceTimingConflict(record) {
  const source = timing(record.source);
  const context = timing(record.model_context);
  if (context && record.target && String(record.model_context).slice(0, context.index).toLowerCase().includes(String(record.target).toLowerCase())) return false;
  return !!(source && context && (source[1] !== context[1] || source[2].replace(/s$/, '').toLowerCase() !== context[2].replace(/s$/, '').toLowerCase()));
}
export function edgeRecordGroups(records) {
  const groups = new Map();
  records.forEach(record => {
    const groupKey = JSON.stringify([record.source_file, record.source, record.target]);
    if (!groups.has(groupKey)) groups.set(groupKey, { source: record.source, target: record.target, sourceFile: record.source_file, results: [], fingerprints: new Map() });
    const group = groups.get(groupKey);
    const fingerprint = JSON.stringify(stableValue(record));
    const existing = group.fingerprints.get(fingerprint);
    if (existing) existing.occurrences += 1;
    else {
      const result = { record, occurrences: 1 };
      group.results.push(result);
      group.fingerprints.set(fingerprint, result);
    }
  });
  return [...groups.values()].map(({ fingerprints, ...group }) => group);
}
export function resultLabel(record) {
  const context = String(record.model_context || '');
  const model = context.match(/model\s+\d+[a-z]?/i)?.[0];
  const ages = [...new Set([...context.matchAll(/age\s+(\d+(?:\.\d+)?)\s*(years?|months?)/gi)].map(match => `Age ${match[1]} ${match[2].toLowerCase()}`))];
  if (model) return [model, ...ages].join(' · ');
  return context || record.description || record.assertion || record.predicate || 'Source result';
}
